import { put, all, takeLatest, fork, call } from "redux-saga/effects";

import { LOGIN_WITH_TOKEN_KEY, REGISTER_GUEST_TO_EVENT } from "./actionType";

import {
  loginWithTokenKeySuccess,
  loginWithTokenKeyFail,
  registerGuestToEventSuccess,
  registerGuestToEventFail,
} from "./action";

import {
  loginWithTokenKeyAPI,
  registerGuestToEventAPI,
} from "../../../helpers/fakebackend_helper";

//loginWithTokenKeyAPI takes (data, token) as parameters

function* loginWithTokenKey(action) {
  try {
    const response = yield call(
      loginWithTokenKeyAPI,
      action?.data,
      action?.token
    );
    yield put(loginWithTokenKeySuccess(response));
  } catch (error) {
    yield put(loginWithTokenKeyFail(error));
  }
}

export function* watchLoginWithTokenKey() {
  yield takeLatest(LOGIN_WITH_TOKEN_KEY, loginWithTokenKey);
}

//registerGuestToEventAPI takes (data, token) as parameters

function* registerGuestToEvent(action) {
  try {
    const response = yield call(
      registerGuestToEventAPI,
      action?.data,
      action?.token
    );
    yield put(registerGuestToEventSuccess(response));
  } catch (error) {
    yield put(registerGuestToEventFail(error));
  }
}

export function* watchRegisterGuestToEvent() {
  yield takeLatest(REGISTER_GUEST_TO_EVENT, registerGuestToEvent);
}

function* EventSaga() {
  yield all([fork(watchLoginWithTokenKey), fork(watchRegisterGuestToEvent)]);
}

export default EventSaga;
